import { AdTabProps } from "./config/tab";
import { memo, PropsWithChildren, useCallback } from "react";
import { useExperiment } from "@/common/hooks/useExperiment";
import { Button } from "@/components/buttons/Button";
import { EXPERIMENT_NO_ADS } from "@/common/services/experiment/constants";
import "./AdTab.scss";

const AdTab = ({ link, children }: AdTabProps & PropsWithChildren) => {
  const { isLoading, variant: noAds } = useExperiment({ key: EXPERIMENT_NO_ADS, fallback: false });

  const handleClick = useCallback(() => {
    window.location.href = link;
  }, [link]);

  if (noAds || isLoading) {
    return null;
  }

  return (
    <Button className="aTab" variant="tertiary" size="s" onClick={handleClick}>{children}</Button>
  );
};

const adTabMemo = memo(AdTab);

export default adTabMemo;
